define(function(require) {

	const CN = require('civicsUtils/constants');
	const Utils = require('civicsUtils/general_utilities');

	return {
		// Common Template Helper Code
		commonHelpers: function(view) {
			var helpers = {
				getReviewState: function() {
					//
					// Review State is one of 3 values:
					// - Closed
					// - Assigned
					// - Not Assigned
					// - Closed if parent instrument is closed
					var assignedToProviderId = typeof view.model.get('assignedToProvider') != 'undefined' ? view.model.get('assignedToProvider.id') : undefined;
					var scheduledDateTime = view.model.get('scheduledDateTime');
					var result = view.model.get('result');

					// if (__DEV__) console.log('common view - assign_review - getInspectionDateState scheduledDateTime: ', scheduledDateTime, ' result: ', result);

					if (typeof result != 'undefined' && result.trim().length > 0) {
						// Has a result
						return view.config.REVIEW_STATE.CLOSED;
					}

					if( view.applicationModel && view.applicationModel.get('PortalStatus') == "Closed" ){
						//parent instrument is in a closed state
						return view.config.REVIEW_STATE.CLOSED;
					}

					if (typeof assignedToProviderId != 'undefined' && assignedToProviderId != 1) {
						// No result, Assigned
						return view.config.REVIEW_STATE.ASSIGNED;
					}

					// None of the above
					return view.config.REVIEW_STATE.NOT_ASSIGNED;
				},
				isReviewRecordingPartiallyComplete: function() {
					var hours = view.model.get('actualTime');
					// if(__DEV__) console.log('common view - assign_review - isRecordingPartiallyComplete ',
					// 			' resultDateTime: ', view.model.get('resultDateTime'),
					// 			' startDateTime: ', view.model.get('startDateTime'),
					// 			' completedDateTime: ', view.model.get('completedDateTime'),
					// 			' hours: ', hours);

					if (!Utils.dateExists(view.model.get('resultDateTime'))){
						if (Utils.dateExists(view.model.get('startDateTime')) ||
							Utils.dateExists(view.model.get('completedDateTime')) ||
							hours > 0) {
							// recording is partially complete
							return true;
						}
					}
					return false;
				},
				//This function is for the old dropdown. 
				selectExistingAssignedToProvider: function(id) {
					if (id == view.model.get('assignedToProvider.id')) {
						return 'selected';
					}
					return '';
				},
				selectDroppyExistingAssignedToProvider: function(id) {
					if (id == view.model.get('assignedToProvider.id')) {
						return true;
					}
					return false;
				},
			};
			//
			// Extending the helpers for properties that need to call other helper functions
			//
			_.extend(helpers, {
				isReviewAssigned: helpers.getReviewState() == view.config.REVIEW_STATE.ASSIGNED,
				isReviewClosed: helpers.getReviewState() == view.config.REVIEW_STATE.CLOSED,
				isReviewNotAssigned: helpers.getReviewState() == view.config.REVIEW_STATE.NOT_ASSIGNED,
				isReviewOpen: helpers.getReviewState() != view.config.REVIEW_STATE.CLOSED,
			});
			return helpers;
		}
	}
});
